import { BrowserDetector } from "@colibrio/colibrio-reader-framework/colibrio-core-base";
import { VanillaVoidCallback } from "../VanillaReader/VanillaReaderModel";
import { VanillaReaderUI } from "./VanillaReaderUI";

/**
 * # VanillaReaderUiSliderProgression
 *
 * ## RESPONSIBILITIES
 *
 * ## RELATED TYPES
 *
 */
export class VanillaReaderUiFunctionButtons {
   
    private _hostDocument: Document;
    private _buttonPanZoomActivate: HTMLElement;
    private _buttonPanZoomDeactivate: HTMLElement;

    private _panZoomActivateCallback: VanillaVoidCallback | undefined;
    private _panZoomDeactivateCallback: VanillaVoidCallback | undefined;

    private _buttonSoundtrackActivate: HTMLElement;
    private _buttonSoundtrackDeactivate: HTMLElement;

    private _startAmbientMediaCallback: VanillaVoidCallback | undefined;
    private _stopAmbientMediaCallback: VanillaVoidCallback | undefined;

    private _buttonSettings: HTMLElement;

    private _enablePanZoomButton: boolean = !BrowserDetector.isPlatform('mobile');



    private _style = `
        <style>    
        #vanilla-reader__main-menu {
            display: flex;
        }
        #vanilla-reader__main-menu > button {        
            font-size: 1.5rem;   
            align-content: center;
            min-width: 48px;
            margin: 8px;
            height: 24px;
            width: auto;
            bottom: 8px;
            transition: opacity, border ease-in-out 0.2s;
            cursor: pointer;
            z-index: 1;
            background-color: transparent;
            color: var(--vanilla-reader__color__ui__foreground-light);
            border: 1px solid transparent;
        }
        #vanilla-reader__menu__button-panzoom-activate > i {
            font-style:normal;
        }
        </style>`;

    private _template = `
        <div id="vanilla-reader__main-menu">
            <button id="vanilla-reader__menu__button-soundtrack-activate" title="Play Soundtrack"><span class="vanilla__button-icon" aria-hidden="true">music_note</span></button>
            <button id="vanilla-reader__menu__button-soundtrack-deactivate" title="Stop Soundtrack"><span class="vanilla__button-icon" aria-hidden="true">music_off</span></button>
            <button id="vanilla-reader__menu__button-panzoom-activate" title="Activate Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_in</span></button>
            <button id="vanilla-reader__menu__button-panzoom-deactivate" title="Exit Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_out_map</span></button>
            <button id="vanilla-reader__menu__button-settings" title="Open settings dialog" accesskey="t"><span class="vanilla__button-icon" aria-hidden="true">settings</span></button>
        </div>
            `;

    constructor(
        private _hostElement: HTMLElement,
        insertPosition: InsertPosition = 'beforeend',
        private _hostContext: VanillaReaderUI,
    ) {
        this._hostDocument = _hostElement.ownerDocument!;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostElement.insertAdjacentHTML('afterbegin', this._style);

        this._buttonPanZoomActivate = this._hostDocument.getElementById('vanilla-reader__menu__button-panzoom-activate')!;
        this._buttonPanZoomDeactivate = this._hostDocument.getElementById('vanilla-reader__menu__button-panzoom-deactivate')!;

        this._buttonSoundtrackActivate = this._hostDocument.getElementById('vanilla-reader__menu__button-soundtrack-activate')!;
        this._buttonSoundtrackDeactivate = this._hostDocument.getElementById('vanilla-reader__menu__button-soundtrack-deactivate')!;

        this._buttonSettings = this._hostDocument.getElementById('vanilla-reader__menu__button-settings')!;


        if(this._enablePanZoomButton) {
            this._buttonPanZoomActivate.addEventListener('click', (_ev) => {
                this._buttonPanZoomActivate.style.display = 'none';
                this._buttonPanZoomDeactivate.style.display = 'flex';

                if (this._panZoomActivateCallback) {
                    this._panZoomActivateCallback();
                }
            });

            this._buttonPanZoomDeactivate.addEventListener('click', (_ev) => {
                this._buttonPanZoomDeactivate.style.display = 'none';
                this._buttonPanZoomActivate.style.display = 'flex';

                if (this._panZoomDeactivateCallback) {
                    this._panZoomDeactivateCallback();
                }
            });
        } else {
            this._buttonPanZoomActivate.style.display = 'none';
        }

        this._buttonPanZoomDeactivate.style.display = 'none';

        this._buttonSoundtrackActivate.style.display = 'none';
        this._buttonSoundtrackDeactivate.style.display = 'none';

        this._buttonSoundtrackActivate.addEventListener('click', (_ev) => {
            this._buttonSoundtrackActivate.style.display = 'none';
            this._buttonSoundtrackDeactivate.style.display = 'flex';
            if (this._startAmbientMediaCallback) {
                this._startAmbientMediaCallback();
            }
        });

        this._buttonSoundtrackDeactivate.addEventListener('click', (_ev) => {
            this._buttonSoundtrackDeactivate.style.display = 'none';
            this._buttonSoundtrackActivate.style.display = 'flex';
            if (this._stopAmbientMediaCallback) {
                this._stopAmbientMediaCallback();
            }
        });


        this._buttonSettings.addEventListener('click', (_ev) => {
            if (this._hostContext.dialogSettings?.isOpen()) {
                this._hostContext.dialogSettings.close();
            } else {
                this._hostContext.dialogSettings?.show();
            }
        });

        
    }

    onPanZoomActivate(callback: VanillaVoidCallback): void {
        this._panZoomActivateCallback = callback;
    }

    onPanZoomDeactivate(callback: VanillaVoidCallback): void {
        this._panZoomDeactivateCallback = callback;
    }

    togglePanZoomButtonState(on: boolean): void {
        if (on) {
            this._buttonPanZoomDeactivate.style.display = 'flex';
            this._buttonPanZoomActivate.style.display = 'none';
        } else {
            this._buttonPanZoomActivate.style.display = 'flex';
            this._buttonPanZoomDeactivate.style.display = 'none';
        }

    }

    enableSoundtrack(isPlaying: boolean): void {
        if (isPlaying) {
            this._buttonSoundtrackActivate.style.display = 'none';
            this._buttonSoundtrackDeactivate.style.display = 'flex';
        } else {
            this._buttonSoundtrackActivate.style.display = 'flex';
            this._buttonSoundtrackDeactivate.style.display = 'none';
        }
    }

    disableSoundtrack(): void {
        this._buttonSoundtrackActivate.style.display = 'none';
        this._buttonSoundtrackDeactivate.style.display = 'none';
    }

    onPlayAmbientMedia(callback: VanillaVoidCallback): void {
        this._startAmbientMediaCallback = callback;
    }

    onStopAmbientMedia(callback: VanillaVoidCallback): void {
        this._stopAmbientMediaCallback = callback;
    }

}
